'use client';

import { FC } from 'react';
import { Scale, X } from 'lucide-react';
import { useTranslations } from 'next-intl';
import styles from './CompareToggleButton.module.scss';
interface Props {
  active: boolean;
  onClick: () => void;
}

/** "Compare" pill beside the view switch. Pressing it again ends compare mode. */
const CompareToggleButton: FC<Props> = ({
  active,
  onClick
}) => {
  const t = useTranslations('compare');
  return <button type="button" className={`${styles.toggle} ${active ? styles.active : ''}`} aria-pressed={active} onClick={onClick} data-sentry-component="CompareToggleButton" data-sentry-source-file="CompareToggleButton.tsx">
            <Scale size={14} strokeWidth={2} aria-hidden="true" data-sentry-element="Scale" data-sentry-source-file="CompareToggleButton.tsx" />
            {t('button')}
            {active && <X size={14} strokeWidth={2.25} aria-hidden="true" />}
        </button>;
};
export default CompareToggleButton;